import React from 'react';
import { motion } from 'framer-motion';
import styles from './PortfolioList.module.css';
import { projects } from '../data/projects';
import { useDockAnimation } from '../hooks/useDockAnimation';
import { useSound } from '../context/SoundContext';

const listVariants = {
  initial: { opacity: 0 },
  in: { opacity: 1, transition: { staggerChildren: 0.1 } },
  out: { opacity: 0 },
};

const itemVariants = {
  initial: { opacity: 0, y: 20 },
  in: { opacity: 1, y: 0 },
};

const ProjectImages = ({ images, projectId, viewProject }) => {
  const {
    currentScales,
    currentPositions,
    handleMouseMove,
    handleMouseLeave,
    baseIconSize,
  } = useDockAnimation(images);
  
  const { playHover, playClick } = useSound();

  return (
    <div
      className={styles.projectImageGrid}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
    >
      {images.map((image, index) => {
        const scale = currentScales[index];
        const position = currentPositions[index] || 0;
        const scaledSize = baseIconSize * scale;

        return (
          <motion.div
            key={index}
            className={styles.projectGalleryImageContainer}
            onMouseEnter={playHover}
            onClick={(e) => {
              e.stopPropagation();
              playClick();
              viewProject(projectId, index);
            }}
            style={{
              position: "absolute",
              left: `${position - scaledSize / 2}px`,
              bottom: "0px",
              width: `${scaledSize}px`,
              height: `${scaledSize}px`,
              transformOrigin: "bottom center",
              zIndex: Math.round(scale * 10),
            }}
          >
            <img
              src={image}
              alt={`Project image ${index + 1}`}
              className={styles.projectGalleryImage}
            />
          </motion.div>
        );
      })}
    </div>
  );
};

const PortfolioList = ({ viewProject }) => {
  const { playHover, playClick } = useSound();
  
  return (
    <motion.div
      variants={listVariants}
      initial="initial"
      animate="in"
      exit="out"
    >
      {projects.map((project) => (
        <motion.div
          key={project.id}
          className={styles.projectRow}
          onMouseEnter={playHover}
          onClick={() => {
            playClick();
            viewProject(project.id, 0);
          }}
          variants={itemVariants}
        >
          <div className={styles.projectHeader}>
            <span className={styles.projectTitle}>{project.title}</span>
            <span className={styles.projectDate}>{project.date}</span>
          </div>
          <ProjectImages
            images={project.images}
            projectId={project.id}
            viewProject={viewProject}
          />
        </motion.div>
      ))}
    </motion.div>
  );
};

export default PortfolioList;